exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index-list-2bXj8{position:relative;display:flex;flex-wrap:nowrap;width:100%;height:100%}.index-vertical-2e6de{overflow-y:auto;overflow-x:hidden;overflow:auto!important;flex-direction:column}.index-vertical-2e6de .index-cell-3pR8r{width:100%}.index-horizontal-orLzZ{overflow-x:auto!important;overflow-y:hidden;flex-direction:row}.index-horizontal-orLzZ .index-cell-3pR8r{height:100%}.index-cell-3pR8r{display:inline-flex;flex:0 0 auto;background-color:#7fffd4}", ""]);

// Exports
exports.locals = {
	"list": "index-list-2bXj8",
	"vertical": "index-vertical-2e6de",
	"cell": "index-cell-3pR8r",
	"horizontal": "index-horizontal-orLzZ"
};